// TODO: Config in eigene Datei exportieren
// to get account_id, create bounce and watch webhooks! :/
// Config per Portal/Account
export const config = {
    accounts: { 
        rn: '4474',
        hz: '4476',
        mlz:'4485',
        dz: '4475',
        ha: '4477',
        brs:'4478',

        dm: '5434',
        hea:'5435',
        mz: '5436',
        rz: '5437',
        sz: '5438',
        wz: '5439',

        bbv: '11906',
    },

    portals: {
        // Portalübergreifend gültig
        'all': {
            thanks: "Vielen Dank für Ihre Anmeldung. Sollten Sie noch keinen Newsletter von uns erhalten, bekommen Sie in Kürze ein E-Mail von uns. Bitte bestätigen Sie mit Klick auf den dort enthaltenen Link Ihre Newsletteranmeldung.",
        },


        // Ruhr Nachrichten
        '4474': {
            name: { short: 'RN', full: 'Ruhr Nachrichten', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/rn/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/rn/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/rn/suppressions/',
            },
            favicon: 'favicon-rn.ico',
            url: 'https://ruhrnachrichten.de',
            aktion: {
                url: '',
                url_text: '',
                text: 'Unser Single-Newsletter „Leben und Lieben“ startet am 17. November. Sie können sich aber schon heute anmelden.',
                startDate: '2021-10-25',
                endDate: '2021-11-17',
            },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/logo_rn.webp',
            // TODO: kann das dynamisch werden? Ich bekomme die ben. Informationen nicht von der API!?
            introHead: "Wichtige Information:",
            introText: "18.11.2024",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "",
            setupInfoText: "Unsere Angebots-, Vorteils-, Sonntags- und Empfehlungsnewsletter können Sie wie gewohnt auf dieser Seite abbestellen. Entfernen Sie einfach das Häkchen bei den Newslettern, die Sie nicht mehr erhalten möchten, und klicken Sie anschließend auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: [
                    // "EM_RN_DO", "EM_RN_LUENEN", "EM_RN_CR", "EM_RN_SCHWERTE", "EM_RN_WERNE", "EM_RN_SELM"
                    ],
                selects: [
                    { key: "EM_RN_DO", value: "EM_RN_DO", label: "Dortmund" },
                    { key: "EM_RN_LUENEN", value: "EM_RN_LUENEN", label: "Lünen" },
                    { key: "EM_RN_CR", value: "EM_RN_CR", label: "Castrop-Rauxel" },
                    { key: "EM_RN_SCHWERTE", value: "EM_RN_SCHWERTE",  label: "Schwerte" },
                    { key: "EM_RN_WERNE", value: "EM_RN_WERNE", label: "Werne" },
                    { key: "EM_RN_SELM", value: "EM_RN_SELM", label: "Selm, Olfen, Nordkirchen" },
                ],
                time: 'Mo-Sa',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat.png',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Stadt. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Ihrer Stadt',
            },
            topicMails: [
                // {
                //     key: "EM_RN_WIRTSCHAFT",
                //     name: 'Unternehmen im Blick: Das Wirtschaftsbriefing für Dortmund',
                //     time: 'Dienstags, ca. 11 Uhr',
                //     text: 'Mittelstandsunternehmen und Großkonzerne, Insolvenzen und Rekordgewinne, neue Jobs und Kündigungen: Dennis Pesch informiert Sie jeden Dienstag um 11 Uhr über das, was die Dortmunder Wirtschaft bewegt.',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/wirtschaft.jpg',
                // },
                // {
                //     key: "EM_RN_CORONA",
                //     name: 'Durchblick am Mittwoch',
                //     time: 'Jeden Mittwoch, ca. 13 Uhr',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                //     text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                // },
                // {
                //     key: "EM_RN_BVB",
                //     name: 'BVB-Newsletter',
                //     time: 'Täglich, ca. 20 Uhr',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/bvb.jpg',
                //     text: 'Bleiben Sie mit uns am Ball und erfahren Sie täglich alle top-aktuellen Neuigkeiten aus der gesamten BVB-Welt. So erhalten Sie alle schwarzgelben Neuigkeiten aus einer Hand.',
                // },
                // {
                //     key: "EM_RN_DO_LOKALSPORT",
                //     name: 'Lokalsport Dortmund',
                //     time: 'Täglich, ca. 18 Uhr',
                //     text: 'Das Wichtigste aus dem Dortmunder Amateurfußball. Jeden Abend neu. Mit unserem Newsletter verpassen Sie keine Dortmunder Fußball-News mehr.',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                // },
                // {
                //     key: "EM_RN_LUENEN_LOKALSPORT",
                //     name: 'Lünen Lokalsport',
                //     time: 'Montags bis freitags, ca. 18:30 Uhr',
                //     text: 'Noch mehr Sport gefällig? Dann melden Sie sich doch auch für Lokalsport-Nachrichten aus Lünen, Selm, Werne, Castrop-Rauxel oder Schwerte an.',
                //     imgUrl: '',
                //     minify: true,
                // },
                // {
                //     key: "EM_RN_SELM_LOKALSPORT",
                //     name: 'Selm Lokalsport',
                //     time: 'Montags bis freitags, ca. 18:30 Uhr',
                //     text: '',
                //     imgUrl: '',
                //     minify: true,
                // },
                // {
                //     key: "EM_RN_WERNE_LOKALSPORT",
                //     name: 'Werne Lokalsport',
                //     time: 'Montags bis freitags, ca. 18:30 Uhr',
                //     text: '',
                //     imgUrl: '',
                //     minify: true,
                // },
                // {
                //     key: "EM_RN_CR_LOKALSPORT",
                //     name: 'Castrop-Rauxel Lokalsport',
                //     time: 'Freitags, ca. 18:30 Uhr',
                //     text: '',
                //     imgUrl: '',
                //     minify: true,
                // },
                // {
                //     key: "EM_RN_SCHWERTE_LOKALSPORT",
                //     name: 'Schwerte Lokalsport',
                //     time: 'Freitags, ca. 18:30 Uhr',
                //     text: '',
                //     imgUrl: '',
                //     minify: true,
                // },
                // {
                //     key: "EM_RN_FOODLOVER",
                //     name: 'Genussecke - der kulinarische Newsletter',
                //     time: 'Jeden Freitag, ca. 17 Uhr',
                //     text: 'Immer freitags bekommen Sie von uns die neusten Infos zu allen kulinarischen Themen, die die Region bewegen.',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/Genussecke.png',
                // },
                // {
                //     key: "EM_RN_IMMOBILIEN",
                //     name: 'Glücklich wohnen - der Immobilien-Newsletter',
                //     time: 'Jeden Freitag, ca. 17 Uhr',
                //     text: 'Ihr Immobilien-Newsletter rund um die Themen Haus, Wohnung und Garten. Alles Wissenswerte, jede Woche neu und direkt aus Ihrer Region.',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/immobilien.jpg',
                // }
            ],
            specialMails: [
                {
                    key: "LM_RN_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_RN_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote zur unserer gedruckten Zeitung, dem ePaper und RN+',
                },
                {
                    key: "LM_RN_SONNTAGS",
                    name: 'ePaper-Service',
                    text: 'Informationen über die aktuelle Ausgabe Ihres ePapers',
                },
                {
                    key: "OB_RN",
                    name: 'RN+ Empfehlungen',
                    text: 'Informationen zu Neuheiten und Vorteilen sowie Aktionen für RN+ Kunden',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_RN_DO", value: "inactive" },
                { key: "Preferences.EM_RN_LUENEN", value: "inactive" },
                { key: "Preferences.EM_RN_CR", value: "inactive" },
                { key: "Preferences.EM_RN_SCHWERTE", value: "inactive" },
                { key: "Preferences.EM_RN_WERNE", value: "inactive" },
                { key: "Preferences.EM_RN_SELM", value: "inactive" },
                { key: "Preferences.EM_RN_DO_LOKALSPORT", value: "inactive" },
                { key: "Preferences.EM_RN_LUENEN_LOKALSPORT", value: "inactive" },
                { key: "Preferences.EM_RN_SELM_LOKALSPORT", value: "inactive" },
                { key: "Preferences.EM_RN_WERNE_LOKALSPORT", value: "inactive" },
                { key: "Preferences.EM_RN_CR_LOKALSPORT", value: "inactive" },
                { key: "Preferences.EM_RN_SCHWERTE_LOKALSPORT", value: "inactive" },
                { key: "Preferences.EM_RN_BVB", value: "inactive" },
                { key: "Preferences.EM_RN_CORONA", value: "inactive" },
                { key: "Preferences.EM_RN_FOODLOVER", value: "inactive" },
                { key: "Preferences.EM_RN_IMMOBILIEN", value: "inactive" },
                { key: "Preferences.EM_RN_WIRTSCHAFT", value: "inactive" },
                { key: "Preferences.LM_RN_ANGEBOT", value: "inactive" },
                { key: "Preferences.LM_RN_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_RN_SONNTAGS", value: "inactive" },
                { key: "Preferences.OB_RN", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "inactive" }
            ],
            footer: {
                copyright: 'Verlag Lensing-Wolff GmbH & Co. KG',
                mailto: 'datenschutz@lensingmedia.de',
                mailto_ls: 'digital@ruhrnachrichten.de',
                links_top: [
                    { key: "top_0", text: "Bei Fragen oder Problemen wenden Sie sich gerne an unseren <a href=\"\">Leserservice</a>"},//, url: "https://www.ruhrnachrichten.de/verlag/abo-digital" },
                    // { key: "top_a", text: "Digitalabo", url: "https://www.ruhrnachrichten.de/verlag/abo-digital" },
                    // { key: "top_b", text: "Weitere Abo-Angebote", url: "https://abo-shop.ruhrnachrichten.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://www.ruhrnachrichten.de/Verlag/Kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://www.ruhrnachrichten.de/Verlag/Datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://www.ruhrnachrichten.de/Verlag/Impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://www.ruhrnachrichten.de/Verlag/Agb" },
                ],
            }
        },

        // Halterner Zeitung
        '4476': {
            name: { short: 'HZ', full: 'Halterner Zeitung', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/hz/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/hz/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/hz/suppressions/',
            },
            favicon: 'favicon-hz.ico',
            url: 'https://halternerzeitung.de',
            aktion: {
                url: 'https://aktion.halternerzeitung.de/wp-content/uploads/sites/5/2021/09/Teilnahmebedingungen-NL-Gewinnspiel-Oktober-2021-Lensing-Media.pdf',
                url_text: 'Teilnahmebedingungen.',
                text: 'Durch eine Anmeldung landen Sie automatisch im Lostopf für unser Europa-Park-Gewinnspiel. Gewinnen Sie eine Übernachtung für 4 Personen, inkl. Frühstück und Eintritt in den Europa-Park. Das Gewinnspiel läuft bis zum 24. Oktober, 23:59 Uhr. Weitere Informationen gibt es in den ',
                startDate: '2021-10-04',
                endDate: '2021-10-24',
            },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/logo_hz.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "11.11.2024",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",

            dailyMails: {
                keys: [
                    // "EM_HZ"
                ],
                selects: [
                    { key: "EM_HZ", value: "EM_HZ", label: "Haltern" },
                ],
                time: 'Mo-Sa',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat.png',
                text: 'Alle wichtigen Neuigkeiten aus Haltern am See. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Haltern am See',
            },
            topicMails: [
                // {
                //     key: "EM_HZ_CORONA",
                //     name: 'Durchblick am Mittwoch',
                //     time: 'Jeden Mittwoch, ca. 13 Uhr',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                //     text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                // },
                // {
                //     key: "EM_HZ_IMMOBILIEN",
                //     name: 'Glücklich wohnen - der Immobilien-Newsletter',
                //     time: 'Jeden Freitag, ca. 17 Uhr',
                //     text: 'Ihr Immobilien-Newsletter rund um die Themen Haus, Wohnung und Garten. Alles Wissenswerte, jede Woche neu und direkt aus Ihrer Region.',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/immobilien.jpg',
                // },
                // {
                //     key: "EM_HZ_LOKALSPORT",
                //     name: 'Das Update aus dem Lokalsport',
                //     time: 'Jeden Freitag, ca. 18:30 Uhr',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                //     text: 'Nachrichten aus dem Amateurfußball und das Wichtigste rund um den Lokalsport in und um Haltern am See. Mit unserem Lokalsport-Newsletter entgeht Ihnen nichts.',
                // },
            ],

            specialMails: [
                {
                    key: "LM_HZ_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_HZ_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote zur unserer gedruckten Zeitung, dem ePaper und HZ+',
                },
                {
                    key: "LM_HZ_DZ_SONNTAGS",
                    name: 'Sonntagszeitung',
                    text: 'Überblick über die aktuellen Themen in Ihrer digitalen Sonntagszeitung',
                },
                {
                    key: "OB_HZ",
                    name: 'HZ+ Empfehlungen',
                    text: 'Informationen zu Neuheiten und Vorteilen sowie Aktionen für HZ+ Kunden',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_HZ", value: "inactive" },
                { key: "Preferences.EM_HZ_CORONA", value: "inactive" },
                { key: "Preferences.EM_HZ_IMMOBILIEN", value: "inactive" },
                { key: "Preferences.EM_HZ_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_HZ_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_HZ_ANGEBOT", value: "inactive" },
                { key: "Preferences.LM_HZ_DZ_SONNTAGS", value: "inactive" },
                { key: "Preferences.OB_HZ", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Verlag Lensing-Wolff GmbH & Co. KG',
                mailto: 'datenschutz@lensingmedia.de',
                mailto_ls: 'digital@halternerzeitung.de',
                links_top: [
                    { key: "top_a", text: "Digitalabo", url: "https://www.halternerzeitung.de/verlag/abo-digital" },
                    // { key: "top_b", text: "Weitere Abo-Angebote", url: "https://abo-shop.halternerzeitung.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://www.halternerzeitung.de/Verlag/Kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://www.halternerzeitung.de/Verlag/Datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://www.halternerzeitung.de/Verlag/Impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://www.halternerzeitung.de/Verlag/Agb" },
                ],
            }
        },

        // MLZ
        '4485': {
            name: { short: 'MLZ', full: 'Münsterland Zeitung', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/mlz/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/mlz/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/mlz/suppressions/',
            },
            favicon: 'favicon-mlz.ico',
            url: 'https://muensterlandzeitung.de',
            aktion: {
                url: 'https://aktion.muensterlandzeitung.de/wp-content/uploads/sites/5/2021/09/Teilnahmebedingungen-NL-Gewinnspiel-Oktober-2021-Lensing-Media.pdf',
                url_text: 'Teilnahmebedingungen.',
                text: 'Durch eine Anmeldung landen Sie automatisch im Lostopf für unser Europa-Park-Gewinnspiel. Gewinnen Sie eine Übernachtung für 4 Personen, inkl. Frühstück und Eintritt in den Europa-Park. Das Gewinnspiel läuft bis zum 24. Oktober, 23:59 Uhr. Weitere Informationen gibt es in den ',
                startDate: '2021-10-04',
                endDate: '2021-10-24',
            },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/logo_mlz.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "11.11.2024",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",

            dailyMails: {
                keys: [
                    // "EM_MLZ_AHAUS_HEEK_LEGDEN", "EM_MLZ_STADTLOHN_VREDEN_SUEDLOHN"
                ],
                selects: [
                    { key: "EM_MLZ_AHAUS_HEEK_LEGDEN", value: "EM_MLZ_AHAUS_HEEK_LEGDEN", label: "Ahaus/Heek/Legden" },
                    { key: "EM_MLZ_STADTLOHN_VREDEN_SUEDLOHN", value: "EM_MLZ_STADTLOHN_VREDEN_SUEDLOHN", label: "Stadtlohn/Vreden/Südlohn" },
                ],
                time: 'Mo-Sa',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat.png',
                text: 'Alle wichtigen Neuigkeiten aus Ahaus, Heek, Legden, Stadtlohn, Südlohn und Vreden. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Ihrer Stadt oder Gemeinde',
            },
            topicMails: [
                // {
                //     key: "EM_MLZ_CORONA",
                //     name: 'Durchblick am Mittwoch',
                //     time: 'Jeden Mittwoch, ca. 13 Uhr',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                //     text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                // },
                // {
                //     key: "EM_MLZ_LOKALSPORT",
                //     name: 'Das Update aus dem Lokalsport',
                //     time: 'Jeden Dienstag & Freitag, ca. 18:30 Uhr',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                //     text: 'Nachrichten aus dem Amateurfußball und das Wichtigste rund um den Lokalsport im Münsterland. Mit unserem Lokalsport-Newsletter entgeht Ihnen nichts.',
                // },
            ],

            specialMails: [
                {
                    key: "LM_MLZ_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_MLZ_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote zur unserer gedruckten Zeitung, dem ePaper und MLZ+',
                },
                {
                    key: "LM_MLZ_SONNTAGS",
                    name: 'Sonntagszeitung',
                    text: 'Überblick über die aktuellen Themen in Ihrer digitalen Sonntagszeitung',
                },
                {
                    key: "OB_MLZ",
                    name: 'MLZ+ Empfehlungen',
                    text: 'Informationen zu Neuheiten und Vorteilen sowie Aktionen für MLZ+ Kunden',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_MLZ_AHAUS_HEEK_LEGDEN", value: "inactive" },
                { key: "Preferences.EM_MLZ_STADTLOHN_VREDEN_SUEDLOHN", value: "inactive" },
                { key: "Preferences.EM_MLZ_CORONA", value: "inactive" },
                { key: "Preferences.EM_MLZ_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_MLZ_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_MLZ_ANGEBOT", value: "inactive" },
                { key: "Preferences.LM_MLZ_SONNTAGS", value: "inactive" },
                { key: "Preferences.OB_MLZ", value: "inactive" },
                { key: "Preferences.EM_MLZ", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Verlag Lensing-Wolff GmbH & Co. KG',
                mailto: 'datenschutz@lensingmedia.de',
                mailto_ls: 'digital@muensterlandzeitung.de',
                links_top: [
                    { key: "top_a", text: "Digitalabo", url: "https://www.muensterlandzeitung.de/verlag/abo-digital" },
                    // { key: "top_b", text: "Weitere Abo-Angebote", url: "https://shop.muensterlandzeitung.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://www.muensterlandzeitung.de/Verlag/Kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://www.muensterlandzeitung.de/Verlag/Datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://www.muensterlandzeitung.de/Verlag/Impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://www.muensterlandzeitung.de/Verlag/Agb" },
                ],
            }
        },

        // DZ
        '4475': {
            name: { short: 'DZ', full: 'Dorstener Zeitung', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/dz/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/dz/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/dz/suppressions/',
            },
            favicon: 'favicon-dz.ico',
            url: 'https://dorstenerzeitung.de',
            aktion: {
                url: 'https://aktion.dorstenerzeitung.de/wp-content/uploads/sites/5/2021/09/Teilnahmebedingungen-NL-Gewinnspiel-Oktober-2021-Lensing-Media.pdf',
                url_text: 'Teilnahmebedingungen.',
                text: 'Durch eine Anmeldung landen Sie automatisch im Lostopf für unser Europa-Park-Gewinnspiel. Gewinnen Sie eine Übernachtung für 4 Personen, inkl. Frühstück und Eintritt in den Europa-Park. Das Gewinnspiel läuft bis zum 24. Oktober, 23:59 Uhr. Weitere Informationen gibt es in den ',
                startDate: '2021-10-04',
                endDate: '2021-10-24',
            },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/logo_dz.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "11.11.2024",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: [
                    // "EM_DZ"
                ],
                selects: [
                    { key: "EM_DZ", value: "EM_DZ", label: "EM_DZ" },
                ],
                time: 'Mo-Sa',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat.png',
                text: 'Alle wichtigen Neuigkeiten aus Dorsten und der Region. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Dorsten',
            },
            topicMails: [
            //     {
            //         key: "EM_DZ_CORONA",
            //         name: 'Durchblick am Mittwoch',
            //         time: 'Jeden Mittwoch, ca. 13 Uhr',
            //         imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
            //         text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
            //     },
            //     {
            //         key: "EM_DZ_IMMOBILIEN",
            //         name: 'Glücklich wohnen - der Immobilien-Newsletter',
            //         time: 'Jeden Freitag, ca. 17 Uhr',
            //         text: 'Ihr Immobilien-Newsletter rund um die Themen Haus, Wohnung und Garten. Alles Wissenswerte, jede Woche neu und direkt aus Ihrer Region.',
            //         imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/immobilien.jpg',
            //     },
            //     {
            //         key: "EM_DZ_LOKALSPORT",
            //         name: 'Das Update aus dem Lokalsport',
            //         time: 'Jeden Freitag, ca. 18:30 Uhr',
            //         imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
            //         text: 'Nachrichten aus dem Amateurfußball und das Wichtigste rund um den Lokalsport in und um Dorsten. Mit unserem Lokalsport-Newsletter entgeht Ihnen nichts.',
            //     },
            ],

            specialMails: [
                {
                    key: "LM_DZ_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_DZ_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote zur unserer gedruckten Zeitung, dem ePaper und DZ+',
                },
                {
                    key: "LM_HZ_DZ_SONNTAGS",
                    name: 'Sonntagszeitung',
                    text: 'Überblick über die aktuellen Themen in Ihrer digitalen Sonntagszeitung',
                },
                {
                    key: "OB_DZ",
                    name: 'DZ+ Empfehlungen',
                    text: 'Informationen zu Neuheiten und Vorteilen sowie Aktionen für DZ+ Kunden',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_DZ", value: "inactive" },
                { key: "Preferences.EM_DZ_CORONA", value: "inactive" },
                { key: "Preferences.EM_DZ_IMMOBILIEN", value: "inactive" },
                { key: "Preferences.EM_DZ_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_DZ_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_DZ_ANGEBOT", value: "inactive" },
                { key: "Preferences.LM_DZ_SONNTAGS", value: "inactive" },
                { key: "Preferences.OB_DZ", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Verlag Lensing-Wolff GmbH & Co. KG',
                mailto: 'datenschutz@lensingmedia.de',
                mailto_ls: 'digital@dorstenerzeitung.de',
                links_top: [
                    { key: "top_a", text: "Digitalabo", url: "https://www.dorstenerzeitung.de/verlag/abo-digital" },
                    // { key: "top_b", text: "Weitere Abo-Angebote", url: "https://shop.dorstenerzeitung.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://www.dorstenerzeitung.de/Verlag/Kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://www.dorstenerzeitung.de/Verlag/Datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://www.dorstenerzeitung.de/Verlag/Impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://www.dorstenerzeitung.de/Verlag/Agb" },
                ],
            }
        },

        // HA
        '4477': {
            name: { short: 'HA', full: 'Hellweger Anzeigers', art_genitiv: 'des' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/ha/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/ha/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/ha/suppressions/',
            },
            favicon: 'favicon-ha.ico',
            url: 'https://hellwegeranzeiger.de',
            aktion: {
                url: '',
                url_text: '',
                text: 'Unser Single-Newsletter „Leben und Lieben“ startet am 17. November. Sie können sich aber schon heute anmelden.',
                startDate: '2021-10-25',
                endDate: '2021-11-17',
            },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/logo_ha.svg',
            imgUrlLogoBtm: 'https://lensingmedia.blob.core.windows.net/rule/img/logo_ha_white.png',
            introHead: "",
            introText: "",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "",
            setupInfoText: "",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: [
                    // "EM_HA_BERGKAMEN", "EM_HA_FROENDENBERG", "EM_HA_HOLZWICKEDE", "EM_HA_KAMEN", "EM_HA_UNNA"
                ],
                selects: [
                    { key: "EM_HA_BERGKAMEN", value: "EM_HA_BERGKAMEN", label: "Bergkamen" },
                    { key: "EM_HA_FROENDENBERG", value: "EM_HA_FROENDENBERG", label: "Fröndenberg" },
                    { key: "EM_HA_HOLZWICKEDE", value: "EM_HA_HOLZWICKEDE", label: "Holzwickede" },
                    { key: "EM_HA_KAMEN", value: "EM_HA_KAMEN", label: "Kamen" },
                    { key: "EM_HA_UNNA", value: "EM_HA_UNNA", label: "Unna" },
                ],
                time: 'Mo-Sa',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat.png',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Stadt. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Ihrer Stadt oder Gemeinde',
            },
            topicMails: [
                // {
                //     key: "EM_HA_SPORT",
                //     name: 'Sport Newsletter',
                //     time: 'Täglich, ca. 18:30 Uhr',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                //     text: 'Das Wichtigste aus dem Lokalsport, vom BVB und Schalke. Jeden Tag neu. Mit unserem Newsletter verpassen Sie keine Sport-News mehr.',
                // },
                // {
                //     key: "EM_HA_CORONA",
                //     name: 'Durchblick am Mittwoch',
                //     time: 'Jeden Mittwoch, ca. 13 Uhr',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                //     text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                // },
                // {
                //     key: "EM_HA_IMMOBILIEN",
                //     name: 'Glücklich wohnen - der Immobilien-Newsletter',
                //     time: 'Jeden Freitag, ca. 17 Uhr',
                //     text: 'Ihr Immobilien-Newsletter rund um die Themen Haus, Wohnung und Garten. Alles Wissenswerte, jede Woche neu und direkt aus Ihrer Region.',
                //     imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/immobilien.jpg',
                // }
            ],
            specialMails: [
                {
                    key: "LM_HA_SONNTAGS",
                    name: 'Erinnerungsnewsletter ePaper',
                    text: 'Mit diesem Service informieren wir Sie, sobald eine neue Ausgabe des ePapers verfügbar ist.',
                },
                {
                    key: "LM_HA_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_HA_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote zur unserer gedruckten Zeitung, dem ePaper und HA+',
                },
                {
                    key: "OB_HA",
                    name: 'HA+ Empfehlungen',
                    text: 'Informationen zu Neuheiten und Vorteilen sowie Aktionen für HA+ Kunden',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_HA_BERGKAMEN", value: "inactive" },
                { key: "Preferences.EM_HA_FROENDENBERG", value: "inactive" },
                { key: "Preferences.EM_HA_HOLZWICKEDE", value: "inactive" },
                { key: "Preferences.EM_HA_KAMEN", value: "inactive" },
                { key: "Preferences.EM_HA_UNNA", value: "inactive" },
                { key: "Preferences.EM_HA_SPORT", value: "inactive" },
                { key: "Preferences.EM_HA_CORONA", value: "inactive" },
                { key: "Preferences.EM_HA_IMMOBILIEN", value: "inactive" },
                { key: "Preferences.LM_HA_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_HA_ANGEBOT", value: "inactive" },
                { key: "Preferences.LM_HA_SONNTAGS", value: "inactive" },
                { key: "Preferences.OB_HA", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Zeitungsverlag Rubens GmbH & Co. KG',
                mailto: 'verlag@hellwegeranzeiger.de',
                mailto_ls: 'service@hellwegeranzeiger.de',
                links_top: [
                    { key: "top_0", text: "Bei Fragen oder Problemen wenden Sie sich gerne an unseren <a href=\"\">Leserservice</a>"}
                    // { key: "top_a", text: "Digitalabo", url: "https://www.hellwegeranzeiger.de/verlag/abo-digital" },
                    // { key: "top_b", text: "Weitere Abo-Angebote", url: "https://www.hellwegeranzeiger.de/Abo/Startseite.html" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://www.hellwegeranzeiger.de/Verlag/Kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://www.hellwegeranzeiger.de/Verlag/Datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://www.hellwegeranzeiger.de/Verlag/Impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://www.hellwegeranzeiger.de/Verlag/Agb" },
                ],
            }
        },

        // Borussini
        '4478': {
            name: { short: 'BRS', full: 'Borussini', art_genitiv: 'von' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/brs/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/brs/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/brs/suppressions/',
            },
            favicon: 'favicon-brs.png',
            url: 'https://www.borussini.de',
            aktion: { url: '', url_text: '', text: '', startDate: '2020-01-01', endDate: '2020-01-01', },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/logo_brs.jpg',
            imgUrlLogoBtm: 'https://lensingmedia.blob.core.windows.net/rule/img/logo_brs.png',
            introHead: "",
            introText: "",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten? Bitte entfernen Sie das Häkchen bei den Newslettern, die sie nicht mehr erhalten möchten.",
            setupInfoText: "",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: [ ],
                selects: [
                    { key: "BR_NEWSLETTER", value: "BR_NEWSLETTER", label: "BR_NEWSLETTER" },
                ],
                time: 'Mo-Sa',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat.png',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Stadt. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Ihrer Stadt',
            },
            topicMails: [ 
                {
                    key: "BR_NEWSLETTER",
                    name: 'Borussini Newsletter',
                    time: 'sporadisch',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/herz.jpg',
                    text: 'Alles für junge BVB-Fans',
                },

            ],
            specialMails: [ ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.BR_NEWSLETTER", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Zeitungsverlag Rubens GmbH & Co. KG',
                mailto: 'verlag@hellwegeranzeiger.de',
                links_top: [
                    { key: "bottom_a", text: "AGB", url: "https://www.borussini.de/agb/" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://www.hellwegeranzeiger.de/Verlag/Datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://www.borussini.de/impressum/" },
                    { key: "bottom_d", text: "Freunde werben", url: "https://www.borussini.de/freundewerben/" },
                    { key: "bottom_e", text: "FAQ", url: "https://www.borussini.de/faqs/" },
                ],
                links_bottom: [
                ],
                class: 'footer_brs',
            }
        },
        // END of Borussini

        // DM
        '5434': {
            name: { short: 'DM', full: 'Dattelner Morgenpost', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/dm/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/dm/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/dm/suppressions/',
            },
            favicon: 'favicon-dm.ico',
            url: 'https://dattelner-morgenpost.de',
            aktion: { url: '', url_text: '', text: 'Unser Lokalsport-Newsletter startet am 19. November. Sie können sich aber schon heute anmelden.', startDate: '2020-01-01', endDate: '2021-11-19', },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/DattelnerMorgenpost_Logo_schwarz.svg',
            imgUrlLogoBtm: 'https://lensingmedia.blob.core.windows.net/rule/img/DattelnerMorgenpost_Logo_weiss.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "Lesen Sie die spannendsten Neuigkeiten - bequem und kostenlos in Ihrem E-Mail-Postfach.",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: ["EM_DM_DATTELN"],
                selects: [
                    { key: "EM_DM_DATTELN", value: "EM_DM_DATTELN", label: "Datteln" },
                ],
                time: 'So-Fr, ca. 18 Uhr',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat_bauer_dm.jpg',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Nähe. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Datteln',
            },
            topicMails: [
                {
                    key: "EM_DM_CORONA",
                    name: 'Durchblick am Mittwoch',
                    time: 'Jeden Mittwoch, ca. 13 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                    text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                },
                {
                    key: "EM_DM_LOKALSPORT",
                    name: 'Lokalsport-Newsletter',
                    time: 'Jeden Freitag, ca. 18:30 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                    text: 'Das Wichtigste aus dem Amateurfußball. Mit unserem Newsletter verpassen Sie keine lokalen Fußball-News mehr.',
                },
            ],
            specialMails: [ 
                {
                    key: "LM_DM_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_DM_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote für unsere gedruckte Zeitung sowie für das ePaper',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_DM_DATTELN", value: "inactive" },
                { key: "Preferences.EM_DM_CORONA", value: "inactive" },
                { key: "Preferences.EM_DM_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_DM_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_DM_ANGEBOT", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Medienhaus Bauer GmbH & Co. KG',
                mailto: 'datenschutz@medienhaus-bauer.de',
                mailto_ls: 'digital@dattelner-morgenpost.de',
                links_top: [
                    { key: "top_a", text: "App downloaden", url: "https://aktion.dattelner-morgenpost.de/app" },
                    { key: "top_b", text: "Abo-Angebote", url: "https://webabo.dattelner-morgenpost.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://dattelner-morgenpost.de/kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://dattelner-morgenpost.de/datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://dattelner-morgenpost.de/impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://dattelner-morgenpost.de/agb" },
                ],
                classCta: 'btn-cta-bauer',
                class: 'footer_bauer',
            }
        },
        // ENDE OF DM

        // HEA
        '5435': {
            name: { short: 'HEA', full: 'Hertener Allgemeine', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/hea/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/hea/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/hea/suppressions/',
            },
            favicon: 'favicon-hea.ico',
            url: 'https://hertener-allgemeine.de',
            aktion: { url: '', url_text: '', text: 'Unser Lokalsport-Newsletter startet am 19. November. Sie können sich aber schon heute anmelden.', startDate: '2020-01-01', endDate: '2021-11-19', },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/HertenerAllgemeine_Logo_schwarz.svg',
            imgUrlLogoBtm: 'https://lensingmedia.blob.core.windows.net/rule/img/HertenerAllgemeine_Logo_weiss.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "Lesen Sie die spannendsten Neuigkeiten - bequem und kostenlos in Ihrem E-Mail-Postfach.",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: ["EM_HEA_HERTEN"],
                selects: [
                    { key: "EM_HEA_HERTEN", value: "EM_HEA_HERTEN", label: "Herten" },
                ],
                time: 'So-Fr, ca. 18 Uhr',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat_bauer_hea.jpg',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Nähe. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Herten',
            },
            topicMails: [
                {
                    key: "EM_HEA_CORONA",
                    name: 'Durchblick am Mittwoch',
                    time: 'Jeden Mittwoch, ca. 13 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                    text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                },
                {
                    key: "EM_HEA_LOKALSPORT",
                    name: 'Lokalsport-Newsletter',
                    time: 'Jeden Freitag, ca. 18:30 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                    text: 'Das Wichtigste aus dem Amateurfußball. Mit unserem Newsletter verpassen Sie keine lokalen Fußball-News mehr.',
                },
            ],
            specialMails: [ 
                {
                    key: "LM_HEA_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_HEA_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote für unsere gedruckte Zeitung sowie für das ePaper',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_HEA_HERTEN", value: "inactive" },
                { key: "Preferences.EM_HEA_CORONA", value: "inactive" },
                { key: "Preferences.EM_HEA_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_HEA_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_HEA_ANGEBOT", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Medienhaus Bauer GmbH & Co. KG',
                mailto: 'datenschutz@medienhaus-bauer.de',
                mailto_ls: 'digital@hertener-allgemeine.de',
                links_top: [
                    { key: "top_a", text: "App downloaden", url: "https://aktion.hertener-allgemeine.de/app" },
                    { key: "top_b", text: "Abo-Angebote", url: "https://webabo.hertener-allgemeine.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://hertener-allgemeine.de/kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://hertener-allgemeine.de/datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://hertener-allgemeine.de/impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://hertener-allgemeine.de/agb" },
                ],
                classCta: 'btn-cta-bauer',
                class: 'footer_bauer',
            }
        },
        // ENDE OF HEA

        // MZ
        '5436': {
            name: { short: 'MZ', full: 'Marler Zeitung', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/mz/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/mz/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/mz/suppressions/',
            },
            favicon: 'favicon-mz.ico',
            url: 'https://marler-zeitung.de',
            aktion: { url: '', url_text: '', text: 'Unser Lokalsport-Newsletter startet am 19. November. Sie können sich aber schon heute anmelden.', startDate: '2020-01-01', endDate: '2021-11-19', },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/MarlerZeitung_Logo_schwarz.svg',
            imgUrlLogoBtm: 'https://lensingmedia.blob.core.windows.net/rule/img/MarlerZeitung_Logo_weiss.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "Lesen Sie die spannendsten Neuigkeiten - bequem und kostenlos in Ihrem E-Mail-Postfach.",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: ["EM_MZ_MARL"],
                selects: [
                    { key: "EM_MZ_MARL", value: "EM_MZ_MARL", label: "Marl" },
                ],
                time: 'So-Fr, ca. 18 Uhr',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat_bauer_mz.jpg',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Nähe. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Marl',
            },
            topicMails: [
                {
                    key: "EM_MZ_CORONA",
                    name: 'Durchblick am Mittwoch',
                    time: 'Jeden Mittwoch, ca. 13 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                    text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                },
                {
                    key: "EM_MZ_LOKALSPORT",
                    name: 'Lokalsport-Newsletter',
                    time: 'Jeden Freitag, ca. 18:30 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                    text: 'Das Wichtigste aus dem Amateurfußball. Mit unserem Newsletter verpassen Sie keine lokalen Fußball-News mehr.',
                },
            ],
            specialMails: [ 
                {
                    key: "LM_MZ_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_MZ_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote für unsere gedruckte Zeitung sowie für das ePaper',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_MZ_MARL", value: "inactive" },
                { key: "Preferences.EM_MZ_CORONA", value: "inactive" },
                { key: "Preferences.EM_MZ_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_MZ_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_MZ_ANGEBOT", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Medienhaus Bauer GmbH & Co. KG',
                mailto: 'datenschutz@medienhaus-bauer.de',
                mailto_ls: 'digital@marler-zeitung.de',
                links_top: [
                    { key: "top_a", text: "App downloaden", url: "https://aktion.marler-zeitung.de/app" },
                    { key: "top_b", text: "Abo-Angebote", url: "https://webabo.marler-zeitung.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://marler-zeitung.de/kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://marler-zeitung.de/datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://marler-zeitung.de/impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://marler-zeitung.de/agb" },
                ],
                classCta: 'btn-cta-bauer',
                class: 'footer_bauer',
            }
        },
        // ENDE OF MZ

        // RZ
        '5437': {
            name: { short: 'RZ', full: 'Recklinghäuser Zeitung', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/rz/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/rz/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/rz/suppressions/',
            },
            favicon: 'favicon-rz.ico',
            url: 'https://recklinghaeuser-zeitung.de',
            aktion: { url: '', url_text: '', text: 'Unser Lokalsport-Newsletter startet am 19. November. Sie können sich aber schon heute anmelden.', startDate: '2020-01-01', endDate: '2021-11-19', },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/RecklinghaeuserZeitung_Logo_schwarz.svg',
            imgUrlLogoBtm: 'https://lensingmedia.blob.core.windows.net/rule/img/RecklinghaeuserZeitung_Logo_weiss.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "Lesen Sie die spannendsten Neuigkeiten - bequem und kostenlos in Ihrem E-Mail-Postfach.",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: ["EM_RZ_RECKLINGHAUSEN"],
                selects: [
                    { key: "EM_RZ_RECKLINGHAUSEN", value: "EM_RZ_RECKLINGHAUSEN", label: "Recklinghausen" },
                ],
                time: 'So-Fr, ca. 18 Uhr',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat_bauer_rz.jpg',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Nähe. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Recklinghausen',
            },
            topicMails: [
                {
                    key: "EM_RZ_CORONA",
                    name: 'Durchblick am Mittwoch',
                    time: 'Jeden Mittwoch, ca. 13 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                    text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                },
                {
                    key: "EM_RZ_SCHALKE",
                    name: 'Schalke 04 Newsletter',
                    time: 'Täglich, ca. 19:04 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/s04_ball.jpg',
                    text: 'Ob Transfergerüchte, exklusive Interviews oder spannende Analysen: Wir versorgen Sie täglich mit allen wichtigen königsblauen Neuigkeiten.',
                },
                {
                    key: "EM_RZ_LOKALSPORT",
                    name: 'Lokalsport-Newsletter',
                    time: 'Jeden Freitag, ca. 18:30 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                    text: 'Das Wichtigste aus dem Amateurfußball. Mit unserem Newsletter verpassen Sie keine lokalen Fußball-News mehr.',
                },
            ],
            specialMails: [
                {
                    key: "LM_RZ_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_RZ_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote für unsere gedruckte Zeitung sowie für das ePaper',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_RZ_RECKLINGHAUSEN", value: "inactive" },
                { key: "Preferences.EM_RZ_CORONA", value: "inactive" },
                { key: "Preferences.EM_RZ_SCHALKE", value: "inactive" },
                { key: "Preferences.EM_RZ_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_RZ_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_RZ_ANGEBOT", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Medienhaus Bauer GmbH & Co. KG',
                mailto: 'datenschutz@medienhaus-bauer.de',
                mailto_ls: 'digital@recklinghaeuser-zeitung.de',
                links_top: [
                    { key: "top_a", text: "App downloaden", url: "https://aktion.recklinghaeuser-zeitung.de/app" },
                    { key: "top_b", text: "Abo-Angebote", url: "https://webabo.recklinghaeuser-zeitung.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://recklinghaeuser-zeitung.de/kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://recklinghaeuser-zeitung.de/datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://recklinghaeuser-zeitung.de/impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://recklinghaeuser-zeitung.de/agb" },
                ],
                classCta: 'btn-cta-bauer',
                class: 'footer_bauer',
            }
        },
        // ENDE OF RZ

        // SZ
        '5438': {
            name: { short: 'SZ', full: 'Stimberg Zeitung', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/sz/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/sz/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/sz/suppressions/',
            },
            favicon: 'favicon-sz.ico',
            url: 'https://stimberg-zeitung.de',
            aktion: { url: '', url_text: '', text: 'Unser Lokalsport-Newsletter startet am 19. November. Sie können sich aber schon heute anmelden.', startDate: '2020-01-01', endDate: '2021-11-19', },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/StimbergZeitung_Logo_schwarz.svg',
            imgUrlLogoBtm: 'https://lensingmedia.blob.core.windows.net/rule/img/StimbergZeitung_Logo_weiss.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "Lesen Sie die spannendsten Neuigkeiten - bequem und kostenlos in Ihrem E-Mail-Postfach.",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: ["EM_SZ_OER_ERKENSCHWICK"],
                selects: [
                    { key: "EM_SZ_OER_ERKENSCHWICK", value: "EM_SZ_OER_ERKENSCHWICK", label: "Oer-Erkenschwick" },
                ],
                time: 'So-Fr, ca. 18 Uhr',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat_bauer_sz.jpg',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Nähe. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Oer-Erkenschwick',
            },
            topicMails: [
                {
                    key: "EM_SZ_CORONA",
                    name: 'Durchblick am Mittwoch',
                    time: 'Jeden Mittwoch, ca. 13 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                    text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                },
                {
                    key: "EM_SZ_LOKALSPORT",
                    name: 'Lokalsport-Newsletter',
                    time: 'Jeden Freitag, ca. 18:30 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                    text: 'Das Wichtigste aus dem Amateurfußball. Mit unserem Newsletter verpassen Sie keine lokalen Fußball-News mehr.',
                },
            ],
            specialMails: [
                {
                    key: "LM_SZ_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_SZ_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote für unsere gedruckte Zeitung sowie für das ePaper',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_SZ_OER_ERKENSCHWICK", value: "inactive" },
                { key: "Preferences.EM_SZ_CORONA", value: "inactive" },
                { key: "Preferences.EM_SZ_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_SZ_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_SZ_ANGEBOT", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Medienhaus Bauer GmbH & Co. KG',
                mailto: 'datenschutz@medienhaus-bauer.de',
                mailto_ls: 'digital@stimberg-zeitung.de',
                links_top: [
                    { key: "top_a", text: "App downloaden", url: "https://aktion.stimberg-zeitung.de/app" },
                    { key: "top_b", text: "Abo-Angebote", url: "https://webabo.stimberg-zeitung.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://stimberg-zeitung.de/kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://stimberg-zeitung.de/datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://stimberg-zeitung.de/impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://stimberg-zeitung.de/agb" },
                ],
                classCta: 'btn-cta-bauer',
                class: 'footer_bauer',
            }
        },
        // ENDE OF SZ

        // WZ
        '5439': {
            name: { short: 'WZ', full: 'Waltroper Zeitung', art_genitiv: 'der' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/wz/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/wz/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/wz/suppressions/',
            },
            favicon: 'favicon-wz.ico',
            url: 'https://waltroper-zeitung.de',
            aktion: { url: '', url_text: '', text: 'Unser Lokalsport-Newsletter startet am 19. November. Sie können sich aber schon heute anmelden.', startDate: '2020-01-01', endDate: '2021-11-19', },
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/WaltroperZeitung_Logo_schwarz.svg',
            imgUrlLogoBtm: 'https://lensingmedia.blob.core.windows.net/rule/img/WaltroperZeitung_Logo_weiss.svg',
            introHead: "Mit unseren kostenlosen Newslettern sind Sie immer bestens informiert:",
            introText: "Lesen Sie die spannendsten Neuigkeiten - bequem und kostenlos in Ihrem E-Mail-Postfach.",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "Möchten Sie in Zukunft weniger Newsletter erhalten oder neue Newsletter hinzubuchen?",
            setupInfoText: "Sie können Ihre Newsletter verwalten, indem Sie das Häkchen bei Newslettern entfernen, die Sie nicht mehr erhalten möchten, oder ein Häkchen bei Newslettern setzen, die sie zusätzlich bekommen möchten. Anschließend klicken Sie unten auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: ["EM_WZ_WALTROP"],
                selects: [
                    { key: "EM_WZ_WALTROP", value: "EM_WZ_WALTROP", label: "Waltrop" },
                ],
                time: 'So-Fr, ca. 18 Uhr',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/heimat_bauer_wz.jpg',
                text: 'Alle wichtigen Neuigkeiten aus Ihrer Nähe. Täglich neu und aktuell. Mit unserem Newsletter werden Sie über alle relevanten Nachrichten und Geschichten aus Ihrer Stadt bestens informiert.',
                name: 'Der Newsletter aus Waltrop',
            },
            topicMails: [
                {
                    key: "EM_WZ_CORONA",
                    name: 'Durchblick am Mittwoch',
                    time: 'Jeden Mittwoch, ca. 13 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/durchblick.jpg',
                    text: 'Ob Neues zu politischen Ereignissen oder aktuellen Krisen: Ulrich Breulmann bringt Sie auf den neusten Stand, ordnet ein und beleuchtet die Auswirkungen auf unsere Region.',
                },
                {
                    key: "EM_WZ_LOKALSPORT",
                    name: 'Lokalsport-Newsletter',
                    time: 'Jeden Freitag, ca. 18:30 Uhr',
                    imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/lokalsport_202107.jpg',
                    text: 'Das Wichtigste aus dem Amateurfußball. Mit unserem Newsletter verpassen Sie keine lokalen Fußball-News mehr.',
                },
            ],
            specialMails: [
                {
                    key: "LM_WZ_VORTEIL",
                    name: 'Abonnenten-Vorteile',
                    text: 'Aktionen & Rabatte – Exklusiv für Abonnenten',
                },
                {
                    key: "LM_WZ_ANGEBOT",
                    name: 'Angebote und Aktionen',
                    text: 'Produktangebote für unsere gedruckte Zeitung sowie für das ePaper',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_WZ_WALTROP", value: "inactive" },
                { key: "Preferences.EM_WZ_CORONA", value: "inactive" },
                { key: "Preferences.EM_WZ_LOKALSPORT", value: "inactive" },
                { key: "Preferences.LM_WZ_VORTEIL", value: "inactive" },
                { key: "Preferences.LM_WZ_ANGEBOT", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Medienhaus Bauer GmbH & Co. KG',
                mailto: 'datenschutz@medienhaus-bauer.de',
                mailto_ls: 'digital@waltroper-zeitung.de',
                links_top: [
                    { key: "top_a", text: "App downloaden", url: "https://aktion.waltroper-zeitung.de/app" },
                    { key: "top_b", text: "Abo-Angebote", url: "https://webabo.waltroper-zeitung.de" },
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://waltroper-zeitung.de/kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://waltroper-zeitung.de/datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://waltroper-zeitung.de/impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://waltroper-zeitung.de/agb" },
                ],
                classCta: 'btn-cta-bauer',
                class: 'footer_bauer',
            }
        },
        // ENDE OF WZ

        // BBV
        '11906': {
            name: { short: 'BBV', full: 'Bocholter Borkener Volksblatt', art_genitiv: 'des' },
            apis: {
                subscriber: 'https://lensingmedia.azure-api.net/rule/bbv/subscriber/',
                subscribers: 'https://lensingmedia.azure-api.net/rule/bbv/subscribers/',
                suppressions: 'https://lensingmedia.azure-api.net/rule/bbv/suppressions/',
            },
            aktion: {
                url: '',
                url_text: '',
                text: 'Unser Single-Newsletter „Leben und Lieben“ startet am 17. November. Sie können sich aber schon heute anmelden.',
                startDate: '2021-10-25',
                endDate: '2021-11-17',
            },
            favicon: 'favicon_bbv.ico',
            url: 'https://www.bbv-net.de/',
            imgUrlLogo: 'https://lensingmedia.blob.core.windows.net/rule/img/BBV_Logo_Digital_Schwarz.svg',
            introHead: "Wichtige Information:",
            introText: "02.06.2025",
            subscrInfoHead: "So funktioniert die Anmeldung:",
            subscrInfoText: "Wählen Sie nachfolgend per Häkchen die Newsletter aus, die sie zukünftig erhalten möchten. Anschließend füllen Sie das unten stehende Formular aus und schicken Ihre Newsletteranmeldung ab.",
            setupInfoHead: "",
            setupInfoText: "Unsere Angebots-, Vorteils-, Sonntags- und Empfehlungsnewsletter können Sie wie gewohnt auf dieser Seite abbestellen. Entfernen Sie einfach das Häkchen bei den Newslettern, die Sie nicht mehr erhalten möchten, und klicken Sie anschließend auf „Newsletter-Änderungen speichern“, um Ihre Änderungen abzuschließen.",
            dailyMailsHead: "Das Wichtigste des Tages",
            dailyMails: {
                keys: [],
                selects: [
                    { key: "EM_BBV_BOCHOLT", value: "EM_BBV_BOCHOLT", label: "Bocholt" },
                ],
                time: 'Mo-So, ca. 18:30 Uhr',
                imgUrl: 'https://lensingmedia.blob.core.windows.net/rule/img/bbv_bocholt.jpg',
                text: 'Wollen Sie stets das Neueste aus Bocholt und Umgebung wissen, bevor es zum Stadtgespräch wird? Unser Newsletter macht es Ihnen leicht – Mit uns verpassen Sie keine wichtigen Nachrichten, denn wir halten Sie täglich auf dem Laufenden.',
                name: 'Der Newsletter aus Bocholt',
            },
            topicMails: [
            ],
            specialMails: [ 
                {
                    key: "LM_BBV_AKTION",
                    name: 'Angebote und Aktionen',
                    text: 'Angebote und Aktionen für unsere gedruckte Zeitung, ePaper und digitalen Produkte.',
                },
            ],
            // full set of inactive fields for PUT/Update
            // XXX: BE CAREFUL! ALL "CITIES" MUST COME FIRST!
            fields: [
                { key: "Preferences.EM_BBV_BOCHOLT", value: "inactive" },
                { key: "Preferences.LM_BBV_AKTION", value: "inactive" },
                // helper-tag for suppression status used for checkbox value
                { key: "Preferences.SUPPRESSED", value: "active" }
            ],
            footer: {
                copyright: 'Temming Verlag GmbH & Co. KG',
                mailto: 'datenschutz@temming-media.de',
                mailto_ls: 'digital@temming-media.de',
                links_top: [
                ],
                links_bottom: [
                    { key: "bottom_a", text: "Kontakt", url: "https://bbv-net.de/kontakt" },
                    { key: "bottom_b", text: "Datenschutz", url: "https://bbv-net.de/datenschutz" },
                    { key: "bottom_c", text: "Impressum", url: "https://bbv-net.de/impressum" },
                    { key: "bottom_d", text: "AGB", url: "https://bbv-net.de/agb" },
                ],
                classCta: 'btn-cta-bbv',
                class: 'footer_bbv',
            }
        },
        // ENDE OF BBV
    },
};